<script setup lang="ts">
import { useFetchPkiConnectivity } from "~/modules/pki/composables/useFetchPkiConnectivity";
import type { Pki } from "~/modules/pki/models/Pki.interface";
import ILxcActivity from "~icons/lxc/activity";

const { t } = useI18n();
const {
  fetchConnectivity,
  isLoading,
  success: successPkiConnectivity,
  fail: errorPkiConnectivity,
} = useFetchPkiConnectivity();

const props = defineProps<{
  pki: Pki;
}>();
</script>

<template>
  <pki-list-test-connection-status
    :success-pki-connectivity="successPkiConnectivity"
    :error-pki-connectivity="errorPkiConnectivity"
    :is-loading="isLoading"
  />
  <lxc-button
    html-type="button"
    type="borderless"
    :is-loading="isLoading"
    :title="t('pki.testConnection.tooltip')"
    :icon="ILxcActivity"
    icon-class="!w-4 !h-4"
    class="invisible"
    @click.stop.prevent="fetchConnectivity(props.pki.alias)"
  />
</template>
